import {useContext, useEffect, useState} from 'react';
import {getCurrentLunchMenu} from "../../../utils/api/lunches";
import Menu from "./menu/Menu";
import LunchInfo from "../../common/lunchInfo/LunchInfo";
import EmptyPlaceholderPage from "../emptyPlaceholder/EmptyPlaceholderPage";
import './CurrentLunchPage.scss';
import Button from "../../common/button/Button";
import {useNavigate} from "react-router-dom";
import {formatDate} from "../../../utils/date";
import {OfficeContext} from "../../../state/OfficeContext";

const CurrentLunchPage = () => {
    const [currentLunch, setCurrentLunch] = useState({});
    const {selectedOffice} = useContext(OfficeContext);
    const navigate = useNavigate();

    useEffect(() => {
        getCurrentLunchMenu(setCurrentLunch);
    }, [selectedOffice]);

    const handleSaveAsTemplateClick = () => {
        navigate('/template', {state: {template: currentLunch}});
    }

    const {endDate, options} = currentLunch;
    const deadline = formatDate(endDate);
    return !currentLunch ? <EmptyPlaceholderPage/> : (
        <div className="current-lunch page">
            <div className="current-lunch--header">
                <p className="page-header">Current Lunch</p>
                <p className="current-lunch--deadline">{deadline}</p>
            </div>
            <LunchInfo lunch={currentLunch}/>
            <Menu options={options}/>
            <Button label="Save as template" onClick={handleSaveAsTemplateClick}/>
        </div>
    );
}

export default CurrentLunchPage;